module.exports = __webpack_public_path__ + "static/img/title-pk-1.c37bdf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/title-pk-1.png
// module id = Rcmi
// module chunks = 1